import { LocalizationContextBuilder } from '@amzn/arb-tools';
import arbManifest from './arbManifest';
import { getDefaultLocaleCurrentDomain } from '../Utils/LocaleHelper';

const DEFAULT_LOCALE = getDefaultLocaleCurrentDomain();
export const INITIAL_LOCALE = JSON.parse(localStorage.getItem('locale') || 'null') || DEFAULT_LOCALE;

export const localizationContextBuilder = new LocalizationContextBuilder().withDefaultLocale(DEFAULT_LOCALE);

export const createMbmOptions = (locale: string) => ({
  arbManifest,
  defaultLocalizationContext: localizationContextBuilder.withLocale(locale).build(),
  resolveBundleUrl: (url?: string) => (url ? `/translations/${url}` : undefined),
});
